import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ProjectValuationTabs } from '../../enum';
import { NavigationBase } from '../../navigation-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';
/**
 * Project valuation navigation component
 */
@Component({
  selector: 'project-valuation-navigation',
  templateUrl: './project-valuation-navigation.component.html',
  styleUrls: ['./project-valuation-navigation.component.css']
})
export class ProjectValuationNavigationComponent extends NavigationBase implements OnInit {
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * Constructor
   * @param appStorage
   * @param eventBus
   * @param ref
   * @param navigationService
   */
  constructor(private appStorage: AppStorageService, eventBus: EventBusService, ref: ChangeDetectorRef, private navigationService: NavigationService) {
    super(eventBus, ref);
    this._ref = ref;
  }
  /**
   * Selected tab
   */
  selectedTab: ProjectValuationTabs = ProjectValuationTabs.Projects;
  /**
   * Search tab visibility
   */
  searchTabVisible = false;
  /**
   * Report inactive
   */
  reportInactive = false;
  /**
   * Tenant inactive
   */
  tenantInactive = true;
  /**
   * Valuation inactive
   */
  valuationInactive = true;
  /**
   * Property inactive
   */
  propertyInactive = false;
  /**
   * ngOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.handleNavigationState();
    this.subscribeToActiveTab();
    this.navigateToValuationEventTab();
  }
  /**
   * Subscribe to active tab
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this.navigationService.activeProjectValuationTab$.subscribe(tab => {
      this.selectedTab = tab;
      this._ref.markForCheck();
    }));
  }
  /**
   * Handle navigation state
   */
  handleNavigationState() {
    this.onEvents.push(this.eventBus.subscribeEvent('setCounterValueBroadcast', (tab, value) => {
      const counterIsZero = value <= 0;
      switch (tab) {
        case 'reports':
          this.reportInactive = counterIsZero;
          break;
        case 'valuation':
          this.valuationInactive = counterIsZero;
          break;
        case 'tenant':
          this.tenantInactive = counterIsZero;
          break;
        case 'property': {
          const isPortfolioSelected = this.appStorage.getSelectedPortfolio(); //If a portfolio is selected, the add property functionality must be available at the property tab in case no properties are added yet
          const isProjectSelected = this.appStorage.getSelectedProject(); //If a portfolio is selected, the add property functionality must be available at the property tab in case no properties are added yet
          this.propertyInactive = counterIsZero && !isPortfolioSelected && !isProjectSelected;

          break;
        }
        default:
          return;//not our tab
      }

      this._ref.markForCheck();
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('navigation:redirectToTab', (tab, callback = null) => {
      this.redirectTo(tab);

      this._ref.markForCheck();

      if (callback) {
        setTimeout(() => {
          callback();
        });
      }
    }));
  }
  /**
   * Redirect to
   * @param tab
   */
  redirectTo(tab: string) {
    this.setSelectedTab(tab);
    this.eventBus.broadcastEvent('valuationTabSelect', tab);
    this.eventBus.broadcastEvent('searchBarVisibility', false, '');
    this.searchTabVisible = false;
  }
  /**
   * Get active tab
   */
  public get activeTab(): typeof ProjectValuationTabs {
    return ProjectValuationTabs;
  }
  /**
   * Set selected tab
   * @param tab
   */
  private setSelectedTab(tab: string) {
    switch (tab) {
      case 'tabProjectstd':
        this.selectedTab = ProjectValuationTabs.Projects;
        break;
      case 'tabReport':
        this.selectedTab = ProjectValuationTabs.Dashboards;
        break;
      case 'tabValuationPortfolio':
        this.selectedTab = ProjectValuationTabs.ValPortofolios;
        break;
      case 'tabProperty':
        this.selectedTab = ProjectValuationTabs.Properties;
        break;
      case 'tabTenant':
        this.selectedTab = ProjectValuationTabs.Tenant;
        break;
      case 'tabValuation':
        this.selectedTab = ProjectValuationTabs.Valuations;
        break;
    }

    this.navigationService.setActiveProjectValuationTab(this.selectedTab);
  }

  /**
   * Navigate to the Valuation Events tab
   */
  private navigateToValuationEventTab() {
    const raciBack = sessionStorage.getItem('raciValuationBack');
    if (raciBack) {
      setTimeout(() => {
        sessionStorage.removeItem('raciValuationBack');
        this.redirectTo('tabValuationPortfolio');
        this._ref.markForCheck();
      }, 1000);
    }
  }
}
